import { render, staticRenderFns } from "./Highlight-edit.vue?vue&type=template&id=43b86f4e&scoped=true&"
import script from "./Highlight-edit.vue?vue&type=script&lang=js&"
export * from "./Highlight-edit.vue?vue&type=script&lang=js&"
import style0 from "./Highlight-edit.vue?vue&type=style&index=0&id=43b86f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b86f4e",
  null
  
)

export default component.exports